//@flow

import React, { Component } from "react";
import RaisedButton from "material-ui/RaisedButton";
import { colors } from "../../../../../../styling";
import ActiveDialog from "./activeDialog";
import { Dialog } from "@mui/material";

type Props = {
  policyId: string;
};

type State = {
  show: boolean;
};

class ActiveState extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  _handleClose: () => void = () => {
    this.setState({ show: false });
  };

  render() {
    const { show } = this.state;
    const { policyId } = this.props;

    return (
      <div>
        <p>
          Update de status van het lid wanneer het lid is overleden, heeft
          opgezegd of is geroyeerd.
        </p>
        <div style={{ textAlign: "center" }}>
          <RaisedButton
            label="Update status"
            backgroundColor={colors.green}
            labelStyle={{ color: "white" }}
            onClick={() => {
              this.setState({ show: true });
            }}
          />
        </div>
        <Dialog open={show} onClose={this._handleClose} fullWidth maxWidth="md">
          <ActiveDialog handleClose={this._handleClose} policyId={policyId} />
        </Dialog>
      </div>
    );
  }
}

export default ActiveState;
